function required(name: string): string {
  const value = import.meta.env[name as keyof ImportMetaEnv];
  if (!value || typeof value !== 'string') {
    throw new Error(`Missing required env var: ${name}`);
  }
  return value;
}

function optional(name: string, fallback: string): string {
  const value = import.meta.env[name as keyof ImportMetaEnv];
  return typeof value === 'string' && value.length > 0 ? value : fallback;
}

export const storageAccount = required('VITE_STORAGE_ACCOUNT');
export const datasetsContainer = required('VITE_DATASETS_CONTAINER');

// The EPFL container holds large folders of data (not catalogue datasets) that
// are listed but never enumerated — see `~lib/storage/epfl`. Defaults to `epfl`
// so existing deployments don't need a new env var to keep working.
export const epflContainer = optional('VITE_EPFL_CONTAINER', 'epfl');

export const blobEndpoint = `https://${storageAccount}.blob.core.windows.net`;
